import React from 'react';
import { useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export function PaymentSuccess() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const closingId = params.get('id');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#121212] p-4">
      <div className="max-w-md w-full bg-white dark:bg-[#1c1c1c] rounded-lg shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle size={32} className="text-green-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Payment Successful!
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Thank you for your purchase. Your Instagram growth journey begins now!
        </p>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Our team will contact you shortly to set up your account and get you started.
        </p>
        <a 
          href="/"
          className="inline-block px-6 py-3 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors"
        >
          Return to Home
        </a>
      </div>
    </div>
  );
}